export const HEAR_ABOUT_US_OPTIONS = [
  { value: 'Search Engine / Online', label: 'Search Engine / Online' },
  { value: 'Family or Friends', label: 'Family or Friends' },
  { value: 'Instagram', label: 'Instagram' },
  { value: 'Facebook', label: 'Facebook' },
  { value: 'TikTok Post', label: 'TikTok Post' },
  { value: 'TikTok Live', label: 'TikTok Live' },
  { value: 'WhatsApp', label: 'WhatsApp' },
  { value: 'Snapchat', label: 'Snapchat' },
  { value: 'Other Social Media', label: 'Other Social Media' },
  { value: 'Email Newsletter', label: 'Email Newsletter' },
  { value: 'SMS Text Message', label: 'SMS Text Message' },
  { value: 'Masjid', label: 'Masjid' },
  { value: 'Event', label: 'Event' },
  { value: 'Podcast', label: 'Podcast' },
  { value: 'Billboard Poster', label: 'Billboard Poster' },
  { value: 'Help Yateem Website', label: 'Help Yateem Website' },
  { value: 'Eman Channel', label: 'Eman Channel' },
  { value: 'Live TV Appeal', label: 'Live TV Appeal' },
  { value: 'Other', label: 'Other' }
];
